/* ============================================================================
   GLORY VACATION MODAL
   
   Presreće klik na "Kreni na plaćanje" ili "Kupi odmah" na svim stranicama
   i prikazuje modal sa porukom da je isporuka odložena (10.02. – 12.02.).
   
   Razlike u odnosu na BiH modal:
   - Nema geo-detekcije (radi za sve posetioce)
   - Nema X dugmeta, samo Potvrdi i Otkazi
   - Dugmici skriveni prvih 3 sekunde (loading bar)
   - Nema localStorage (uvek iskače)
   - "Buy Now" NE dodaje proizvod u korpu jer kupac može da otkaže
   ============================================================================ */

(function() {
  'use strict';

  // ========================================
  // KONSTANTE
  // ========================================
  var MODAL_ID = 'glory-vacation-modal';
  var OVERLAY_ID = 'glory-vacation-overlay';
  var BUTTONS_DELAY_MS = 3000;  // 3 sekunde dok se dugmici pojave
  
  // Datumi isporuke — UREDI OVDE ako se menjaju
  var DELIVERY_DATES = '10.02. – 12.02.';
  
  // Tracking — referenca na originalni klik element, da bismo nastavili checkout flow
  var pendingAction = null;  // { type: 'checkout' | 'buynow', originalElement: ..., originalEvent: ... }

  // ========================================
  // MODAL — KREIRANJE I PRIKAZ
  // ========================================

  function createModal() {
    // Ako već postoji, ukloni (defensive)
    var existing = document.getElementById(MODAL_ID);
    if (existing) existing.remove();
    var existingOverlay = document.getElementById(OVERLAY_ID);
    if (existingOverlay) existingOverlay.remove();

    // OVERLAY — brute-force inline style sa !important (isti pristup kao BiH modal)
    var overlay = document.createElement('div');
    overlay.id = OVERLAY_ID;
    overlay.className = 'glory-vacation-modal__overlay';
    overlay.style.cssText = [
      'display: block',
      'visibility: visible',
      'position: fixed',
      'top: 0',
      'left: 0',
      'right: 0',
      'bottom: 0',
      'width: 100vw',
      'height: 100vh',
      'background-color: rgba(0, 0, 0, 0.85)',
      'z-index: 2147483646',
      'opacity: 0',
      'transition: opacity 0.25s ease',
      'pointer-events: auto'
    ].join(' !important;') + ' !important;';

    // MODAL
    var modal = document.createElement('div');
    modal.id = MODAL_ID;
    modal.className = 'glory-vacation-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'glory-vacation-modal-title');
    modal.style.zIndex = '2147483647';

    modal.innerHTML = [
      '<div class="glory-vacation-modal__header">',
      '  <div class="glory-vacation-modal__icon">',
      '    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">',
      '      <rect x="3" y="5" width="18" height="16" rx="2"/>',
      '      <line x1="3" y1="10" x2="21" y2="10"/>',
      '      <line x1="8" y1="3" x2="8" y2="7"/>',
      '      <line x1="16" y1="3" x2="16" y2="7"/>',
      '    </svg>',
      '  </div>',
      '  <h2 id="glory-vacation-modal-title" class="glory-vacation-modal__title">Važno obaveštenje</h2>',
      '  <p class="glory-vacation-modal__subtitle">Pre nastavka kupovine</p>',
      '</div>',
      '',
      '<div class="glory-vacation-modal__body">',
      '  <p class="glory-vacation-modal__message">',
      '    Hvala na poverenju! Trenutno smo na <strong>kratkoj pauzi</strong>, pa će vaša porudžbina biti poslata u terminu navedenom ispod.',
      '  </p>',
      '  <div class="glory-vacation-modal__dates">',
      '    <span class="glory-vacation-modal__dates-label">Period isporuke</span>',
      '    <span class="glory-vacation-modal__dates-value">' + DELIVERY_DATES + '</span>',
      '  </div>',
      '  <p class="glory-vacation-modal__message" style="margin-top:16px; font-size:13px;">',
      '    Klikom na <strong>Potvrdi</strong> prihvatate ovaj rok isporuke i nastavljate na plaćanje.',
      '  </p>',
      '</div>',
      '',
      '<div class="glory-vacation-modal__footer">',
      '  <div class="glory-vacation-modal__loading" data-loading>',
      '    <span class="glory-vacation-modal__loading-text">Molimo pročitajte poruku...</span>',
      '    <div class="glory-vacation-modal__loading-bar">',
      '      <div class="glory-vacation-modal__loading-fill" data-loading-fill></div>',
      '    </div>',
      '  </div>',
      '  <div class="glory-vacation-modal__buttons" data-buttons>',
      '    <button type="button" class="glory-vacation-modal__btn glory-vacation-modal__btn--cancel" data-action="cancel">',
      '      Otkaži',
      '    </button>',
      '    <button type="button" class="glory-vacation-modal__btn glory-vacation-modal__btn--confirm" data-action="confirm">',
      '      Potvrdi',
      '    </button>',
      '  </div>',
      '</div>'
    ].join('\n');

    document.body.appendChild(overlay);
    document.body.appendChild(modal);

    // Body scroll lock
    document.body.style.overflow = 'hidden';

    // Fade-in animacija
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        overlay.style.setProperty('opacity', '1', 'important');
        overlay.classList.add('is-active');
        modal.classList.add('is-active');
        
        // Pokreni loading bar
        var fill = modal.querySelector('[data-loading-fill]');
        if (fill) {
          requestAnimationFrame(function() {
            fill.classList.add('is-running');
          });
        }
      });
    });

    // Posle 3 sekunde — sakrij loading, prikaži dugmice
    setTimeout(function() {
      var loading = modal.querySelector('[data-loading]');
      var buttons = modal.querySelector('[data-buttons]');
      if (loading) loading.classList.add('is-hidden');
      if (buttons) buttons.classList.add('is-visible');
    }, BUTTONS_DELAY_MS);

    // Handlers
    modal.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      
      var action = btn.getAttribute('data-action');
      if (action === 'confirm') {
        handleConfirm();
      } else if (action === 'cancel') {
        handleCancel();
      }
    });

    // ESC key — tretiramo kao Otkazi
    function escHandler(e) {
      if (e.key === 'Escape') {
        // Samo radi ako su dugmici već vidljivi (posle 3s)
        var buttons = modal.querySelector('[data-buttons]');
        if (buttons && buttons.classList.contains('is-visible')) {
          handleCancel();
          document.removeEventListener('keydown', escHandler);
        }
      }
    }
    document.addEventListener('keydown', escHandler);
    
    // Klik na overlay — NE zatvara (kupac mora svesno da odluči)
    // Ako želiš da overlay zatvara, dekomentariši sledeće linije:
    // overlay.addEventListener('click', function() {
    //   var buttons = modal.querySelector('[data-buttons]');
    //   if (buttons && buttons.classList.contains('is-visible')) handleCancel();
    // });
  }

  function closeModal() {
    var modal = document.getElementById(MODAL_ID);
    var overlay = document.getElementById(OVERLAY_ID);
    if (!modal) return;

    modal.classList.remove('is-active');
    if (overlay) {
      overlay.classList.remove('is-active');
      overlay.style.setProperty('opacity', '0', 'important');
    }

    setTimeout(function() {
      if (modal) modal.remove();
      if (overlay) overlay.remove();
      document.body.style.overflow = '';
    }, 300);
  }

  // ========================================
  // ACTION HANDLERI
  // ========================================

  function handleConfirm() {
    var action = pendingAction;
    closeModal();
    
    if (!action) {
      // Defensive fallback — direktno na checkout
      window.location.href = '/checkout';
      return;
    }
    
    if (action.type === 'checkout') {
      // CHECKOUT — proizvod je već u korpi, samo idi na checkout
      // Pokušaj da nađeš href ako je <a>, inače direktan redirect
      var el = action.originalElement;
      if (el && el.tagName === 'A' && el.href) {
        window.location.href = el.href;
      } else if (el && el.closest('form')) {
        // Submit forme (cart page form)
        el.closest('form').submit();
      } else {
        window.location.href = '/checkout';
      }
    } else if (action.type === 'buynow') {
      // BUY NOW — moramo prvo dodati proizvod u korpu, pa onda na checkout
      addToCartAndCheckout(action.originalElement);
    }
    
    pendingAction = null;
  }

  function handleCancel() {
    pendingAction = null;
    closeModal();
    // Ostavi kupca tamo gde je bio — nema redirecta
  }

  /**
   * Za Buy Now flow — dodaje proizvod u korpu, pa redirect na checkout.
   */
  function addToCartAndCheckout(btn) {
    var form = btn ? btn.closest('form') : null;
    if (!form) form = document.getElementById('GloryProductForm');
    if (!form) form = document.querySelector('form[action*="/cart/add"]');
    
    if (!form) {
      console.error('[Glory Vacation Modal] Buy Now: nema form');
      window.location.href = '/checkout';
      return;
    }

    var formData = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { 'Accept': 'application/json' }
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Add to cart failed (' + r.status + ')');
      return r.json();
    })
    .then(function() {
      // Direktno na checkout
      window.location.href = '/checkout';
    })
    .catch(function(err) {
      console.error('[Glory Vacation Modal] Buy Now error:', err);
      window.location.href = '/checkout';
    });
  }

  // ========================================
  // EVENT BINDING
  // ========================================

  function bindCheckoutButtons() {
    // CHECKOUT — korpa je već popunjena
    var CHECKOUT_SELECTORS = [
      // Cart drawer Glory custom
      '.glory-cart-drawer__checkout',
      'a.glory-cart-drawer__checkout',
      'button.glory-cart-drawer__checkout',
      // Cart drawer Dawn default
      '#CartDrawer-Checkout',
      'cart-drawer button[name="checkout"]',
      // Cart page Glory custom CTA
      '.glory-cart-page__checkout-cta',
      'a.glory-cart-page__checkout-cta',
      // Cart page form (Dawn default)
      'form[action="/cart"] button[name="checkout"]',
      'form[action="/checkout"] button[type="submit"]',
      // Dynamic checkout buttons (Shop Pay, PayPal, GPay itd. — generički selektori)
      '.shopify-payment-button__button'
    ].join(', ');

    // BUY NOW
    var BUY_NOW_SELECTORS = [
      '#GloryBuyNowButton',
      '.glory-product-form__buy-now',
      'button[data-glory-buy-now]',
      'button.glory-buy-now'
    ].join(', ');

    document.body.addEventListener('click', function(e) {
      // Ako je modal već otvoren, ignoriši (njegovi handler-i rade interno)
      if (document.getElementById(MODAL_ID)) return;

      var buyNow = e.target.closest(BUY_NOW_SELECTORS);
      if (buyNow) {
        e.preventDefault();
        e.stopPropagation();
        pendingAction = {
          type: 'buynow',
          originalElement: buyNow
        };
        createModal();
        return;
      }

      var checkout = e.target.closest(CHECKOUT_SELECTORS);
      if (checkout) {
        e.preventDefault();
        e.stopPropagation();
        pendingAction = {
          type: 'checkout',
          originalElement: checkout
        };
        createModal();
        return;
      }
    }, true);  // capture = true — uhvati PRE drugih handler-a
  }

  // ========================================
  // INIT
  // ========================================
  
  function init() {
    bindCheckoutButtons();
    console.log('[Glory Vacation Modal] Initialized. Delivery: ' + DELIVERY_DATES);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
